
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "link-hidden",
  components: {},
})
export class LinkHidden extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.enabled = JSON.parse(JSON.stringify(this.value));
  }
  @Prop({ required: true }) textLink!: string;
  @Prop({ required: true }) textLinkToggle!: string;

  enabled = true;

  toggleActive(): void {
    this.enabled = !this.enabled;
    this.$emit("input", this.enabled);
  }
}

export default LinkHidden;
